import sectionCardReview02Css from '../css-snippets/section-card-review-02';

const html = ` 
<style>${sectionCardReview02Css}</style>
<div
  class="card-review-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-button-animation-show="true"
  data-button-show="true"
>
  <div class="card-review-container container" data-position="right">
    <div class="card-review-left">
      <div class="card-review-image">
        <img
          src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a10e78c39126af73c221ee.webp?w=500&h=50&q=80"
          alt="image" 
        />
      </div>
      <div class="card-review-button-container mobile">
        <a
          href="#"
          class="card-review-button"
        >
         <span class="card-review-button-text">ORDER NOW AND SAVE!</span>
          <span class="card-review-button-arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </span>
        </a>
        <div class="card-review-footer">
          <p style="text-align: center">*Ships by 1 March • 1 Yr Warranty</p>
        </div>
      </div>
    </div>
    <div class="card-review-right">
      <div data-full-stars="5" class="card-review-wrap-stars">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="0"
          height="0"
          style="position: absolute"
        >
          <defs>
            <linearGradient
              id="half-star-gradient-infinite"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop offset="50%" style="stop-color: #f0b100; stop-opacity: 1" />
              <stop offset="50%" style="stop-color: #f0b100; stop-opacity: 0" />
            </linearGradient>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
          ></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
          ></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
          ></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
          ></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
          ></path>
        </svg>
        <span class="card-review-rating-text">4.8 Rating From 52,427+</span>
      </div>
      <div class="card-review-content">
        <h2>
          <strong>90 Day Money Back Guarantee(excl. S&H)</strong>
        </h2>
        <p>
          Enjoy the convenience and peace of mind knowing you're prepared for
          anything. With more than 54,234+ reviews, Airmoto is the most trusted
          brand for portable tire inflators.
        </p>
      </div>
      <div class="card-review-list">
        <div class="card-review-item">
          <div class="card-review-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a1129c383231907a27ff4c.png?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-review-item-text">
            <p>
              <strong>Guaranteed Satisfaction</strong>
            </p>
          </div>
        </div>
        <div class="card-review-item">
          <div class="card-review-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a1129c383231907a27ff4c.png?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-review-item-text">
            <p>
              <strong>Friendly and Fast Support</strong>
            </p>
          </div>
        </div>
        <div class="card-review-item">
          <div class="card-review-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a1129c383231907a27ff4c.png?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-review-item-text">
            <p>
              <strong>90 Day Guarantee(excl. S&H)</strong>
            </p>
          </div>
        </div>
      </div>
      <div class="card-review-button-container desktop">
        <a
          href="#"
          class="card-review-button"
        >
          <span class="card-review-button-text">ORDER NOW AND SAVE!</span>
          <span class="card-review-button-arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </span>
        </a>
        <div class="card-review-footer">
          <p style="text-align: center">*Ships by 1 March • 1 Yr Warranty</p>
        </div>
      </div>
    </div>
  </div>
</div>

`;

export default html;
